import { ErrorHandler, Injectable, inject } from '@angular/core';
import { SlackErrorReporterService } from './slack-error-reporter.service';

@Injectable({ providedIn: 'root' })
export class SlackErrorHandler implements ErrorHandler {
  private readonly reporter = inject(SlackErrorReporterService);

  handleError(error: unknown): void {
    try {
      this.reporter.report({ error, source: 'errorHandler' });
    } catch {
      // não deixa o reporter mascarar erros legítimos no console
    }
    console.error(error);
  }
}
